<template>
  <div class="home-con">
    <dom-box
      :box-style="{
        left: '1137px',
        bottom: '580px',
        width: '2139px',
        height: '1253px',
        borderRadius: 0,
        transform: 'scale(1.6)',
        background: 'transparent'
      }"
      content-type="mainMap"
    ></dom-box>
  </div>
</template>
<script>
import domBox from '../../components/domBox/box'
export default {
  data() {
    return {}
  },
  mounted() {},
  components: {
    domBox
  },
  methods: {}
}
</script>
 <style lang="scss" scoped>
.home-con {
  position: relative;
  height: 100%;
  perspective: 1200px;
}
</style>




// WEBPACK FOOTER //
// src/pages/page1/press1.vue